import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getSoftwareAppLinks } from '../../Constant';

class sidebar extends Component {
  state = {
    rolesList: [],
    Admin: '',
  };
  componentWillMount() {
    // this.props.getRole();
  }

  componentWillReceiveProps(nextProps) {
    // console.log("data",data);/
  }

  constructor(props) {
    super(props);
    this.state = {
      Tab: 'index',
      SubTab: '',
      MoreTab: '',
      dashboard_menu: false,
      email_menu: false,
      ui_menu: false,
      timeOff: false,
      form_menu: false,
      chart_menu: false,
      table_menu: false,
      icon_menu: false,
      map_menu: false,
      analyze: false,
      auth_menu: false,
      extra_menu: false,
      eco_menu: false,
      emt_menu: false,
      user_menu: false,
      roles_menu: false,
      wallet: false,
      banks: false,
      category: false,
      orders: false,
      master: false,
      project: false,
      reportedPosts: false,
      monitoring: false,
      timeSheet: false,
      chats: false,
    };
  }

  setActiveTab = (tab, subtab, moretab, toggleTab, e) => {
    this.setState({ Tab: tab, SubTab: subtab, MoreTab: moretab });
    console.log('TT', tab, subtab, moretab, toggleTab);
  };

  componentDidMount() {
    var now_route = '';
    var pageUrl = window.location.pathname.split(/[?#]/)[0];
    now_route = pageUrl.substr(1).replace(/_/g, ' ');
    $('#now_routing').empty();
    if (now_route == '') {
      now_route = 'Dashboard';
    } else {
    }
    $('#now_routing').append(now_route);

    $('.toggle-search').on('click', function () {
      var targetId = $(this).data('target');
      var $searchBar;
      if (targetId) {
        $searchBar = $(targetId);
        $searchBar.toggleClass('open');
      }
    });

    $('.button-menu-mobile').on('click', function (event) {
      event.preventDefault();
      $('body').toggleClass('enlarged');
    });

    $('li.has_sub li').on('click', function (event) {
      $('body').toggleClass('enlarged');
    });
  }
  componentDidUpdate() {
    var now_route = '';
    var pageUrl = window.location.pathname.split(/[?#]/)[0];
    now_route = pageUrl.substr(1).replace('_', ' ');
    $('#now_routing').empty();
    if (now_route == '') {
      now_route = 'Dashboard';
    } else {
    }
    $('#now_routing').append(now_route);
  }

  render() {
    // const { roleList } = this.props;

    return (
      <div className="left side-menu">
        <div className="topbar-left">
          <div className="">
            <Link to="/" className="logo">
              <img src="/assets/images/logo.webp" height="45" alt="logo" />
            </Link>
          </div>
        </div>

        <div className="sidebar-inner slimscrollleft">
          <PerfectScrollbar>
            <div id="sidebar-menu">
              <ul>
                {/* <li className="menu-title">Main</li> */}
                <li>
                  <Link
                    className={
                      this.state.SubTab === 'dashboard' ? 'active-menu' : ''
                    }
                    onClick={this.setActiveTab.bind(
                      this,
                      'index',
                      'dashboard',
                      ''
                    )}
                    to="/"
                  >
                    <i className="typcn typcn-th-large-outline"></i>Dashboard
                  </Link>
                </li>

                <li
                  className={
                    this.state.timeSheet
                      ? 'has_sub active-menu nav-active'
                      : 'has_sub'
                  }
                  id="a87ec3a0-83a8-4441-9813-e53faaaa951e"
                >
                  <Link
                    to="#"
                    onClick={() =>
                      this.setState({
                        timeSheet: !this.state.timeSheet,
                        analyze: false,
                        product: false,
                        monitoring: false,
                        project: false,
                        timeOff: false,
                        table_menu: false,
                        icon_menu: false,
                        map_menu: false,
                        auth_menu: false,
                        extra_menu: false,
                        eco_menu: false,
                        emt_menu: false,
                      })
                    }
                    className={
                      this.state.Tab === 'master'
                        ? 'waves-effect active-menu'
                        : 'waves-effect'
                    }
                  >
                    <i className="mdi mdi-alarm-check"></i>{' '}
                    <span>
                      Timesheets
                      <span className="pull-right">
                        <i className="mdi mdi-chevron-right"></i>
                      </span>{' '}
                    </span>{' '}
                  </Link>
                  <ul
                    className="list-unstyled"
                    style={{ display: this.state.timeSheet ? 'block' : 'none' }}
                  >
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'Timesheet' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'Timesheet', '')}
                        to="/view-timesheet"
                      >
                        View Timesheet
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        className={
                          this.state.SubTab === 'Time Editor'
                            ? 'active-menu'
                            : ''
                        }
                        onClick={this.setActiveTab.bind(
                          this,
                          'Time Editor',
                          ''
                        )}
                        to="/time-editor"
                      >
                        Time Editor{' '}
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'Time Request'
                            ? 'active-menu'
                            : ''
                        }
                        onClick={this.setActiveTab.bind(
                          this,
                          'Time Request',
                          ''
                        )}
                        to="/time-requests"
                      >
                        Time Request
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="menu-title">ANALYZE</li>

                <li>
                  <Link
                    className={
                      this.state.SubTab === 'realtime' ? 'active-menu' : ''
                    }
                    // onClick={this.setActiveTab.bind(
                    //   this,
                    //   'index',
                    //   'realtime',
                    //   ''
                    // )}
                    to="#"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="mdi mdi-clock"></i> Real Time
                  </Link>
                </li>

                <li
                  className={
                    this.state.analyze
                      ? 'has_sub active-menu nav-active'
                      : 'has_sub'
                  }
                >
                  <Link
                    to="#"
                    onClick={() =>
                      this.setState({
                        analyze: !this.state.analyze,
                        dashboard_menu: false,
                        product: false,
                        ui_menu: false,
                        monitoring: false,
                        chart_menu: false,
                        table_menu: false,
                        icon_menu: false,
                        map_menu: false,
                        auth_menu: false,
                        extra_menu: false,
                        eco_menu: false,
                        emt_menu: false,
                      })
                    }
                    className={
                      this.state.Tab === 'master'
                        ? 'waves-effect active-menu'
                        : 'waves-effect'
                    }
                  >
                    <i className="mdi mdi-note-text"></i>{' '}
                    <span>
                      Reports
                      <span className="pull-right">
                        <i className="mdi mdi-chevron-right"></i>
                      </span>{' '}
                    </span>{' '}
                  </Link>
                  <ul
                    className="list-unstyled"
                    style={{ display: this.state.analyze ? 'block' : 'none' }}
                  >
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'Tracked' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'Tracked', '')}
                        to="/tracked-hours"
                      >
                        Tracked Hours
                      </Link>
                    </li>

                    {/* <li>
                      <Link
                        className={
                          this.state.SubTab === 'Tracked Minute Wise'
                            ? 'active-menu'
                            : ''
                        }
                        onClick={this.setActiveTab.bind(
                          this,
                          'Tracked Minute Wise',
                          ''
                        )}
                        to="/tracked-hours-minute-wise"
                      >
                        Tracked Hours Minute Wise
                      </Link>
                    </li> */}

                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'attendance'
                            ? 'active-menu'
                            : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'attendance', '')}
                        to="/attendance"
                      >
                        Attendance
                      </Link>
                    </li>

                    {/* <li>
                      <Link
                        className={
                          this.state.SubTab === 'Attendance Minute Wise'
                            ? 'active-menu'
                            : ''
                        }
                        onClick={this.setActiveTab.bind(
                          this,
                          'Attendance Minute Wise',
                          ''
                        )}
                        to="/attendance-minute-wise"
                      >
                        Attendance Minute Wise
                      </Link>
                    </li> */}

                    {/* <li>
                      <Link
                        className={
                          this.state.SubTab === 'Activity Level'
                            ? 'active-menu'
                            : ''
                        }
                        onClick={this.setActiveTab.bind(
                          this,
                          'Activity Level',
                          ''
                        )}
                        to="/activity-level"
                      >
                        Activity Level
                      </Link>
                    </li> */}
                    {/* <li><Link className={this.state.SubTab === 'Productivity' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'Productivity','')}  to="/prductivity">Productivity </Link></li> */}
                    {/* <li><Link className={this.state.SubTab === 'apps' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'apps','')}  to="/apps-and-website">Apps & Website</Link></li> */}
                    {/* <li><Link className={this.state.SubTab === 'Finance' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'Finance','')}  to="/finance-reports">Finance</Link></li> */}
                    {/* <li><Link className={this.state.SubTab === 'allReports' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'allReports','')}  to="/all-reports">All Reports</Link></li> */}
                  </ul>
                </li>

                <li
                  className={
                    this.state.monitoring
                      ? 'has_sub active-menu nav-active'
                      : 'has_sub'
                  }
                  id="a87ec3a0-83a8-4441-9813-e53faaaa951e"
                >
                  <Link
                    to="#"
                    onClick={() =>
                      this.setState({
                        monitoring: !this.state.monitoring,
                        analyze: false,
                        product: false,
                        ui_menu: false,
                        project: false,
                        timeOff: false,
                        table_menu: false,
                        icon_menu: false,
                        map_menu: false,
                        auth_menu: false,
                        extra_menu: false,
                        eco_menu: false,
                        emt_menu: false,
                      })
                    }
                    className={
                      this.state.Tab === 'master'
                        ? 'waves-effect active-menu'
                        : 'waves-effect'
                    }
                  >
                    <i className="mdi mdi-chart-line"></i>{' '}
                    <span>
                      Monitoring
                      <span className="pull-right">
                        <i className="mdi mdi-chevron-right"></i>
                      </span>{' '}
                    </span>{' '}
                  </Link>
                  <ul
                    className="list-unstyled"
                    style={{
                      display: this.state.monitoring ? 'block' : 'none',
                    }}
                  >
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'Scrren' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'Scrren', '')}
                        to="/screenshots"
                      >
                        Screenshots{' '}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'Activity' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'Activity', '')}
                        to="/daily-activity"
                      >
                        Daily Activity
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'InternetSpeedLocation'
                            ? 'active-menu'
                            : ''
                        }
                        onClick={this.setActiveTab.bind(
                          this,
                          'InternetSpeedLocation',
                          ''
                        )}
                        to="/internet-speed-location"
                      >
                        Internet Speed / Location
                      </Link>
                    </li>
                    {/* <li><Link className={this.state.SubTab === 'Completed Auction' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'Completed Auction','')}  to="/product-AuctionCompleted">Completed Auction</Link></li> */}
                  </ul>
                </li>

                <li className="menu-title">MANAGE</li>

                <li
                  className={
                    this.state.product
                      ? 'has_sub active-menu nav-active'
                      : 'has_sub'
                  }
                  id="a87ec3a0-83a8-4441-9813-e53faaaa951e"
                >
                  <Link
                    to="#"
                    onClick={() =>
                      this.setState({
                        product: !this.state.product,
                        dashboard_menu: false,
                        monitoring: false,
                        project: false,
                        timeOff: false,
                        chart_menu: false,
                        table_menu: false,
                        icon_menu: false,
                        map_menu: false,
                        auth_menu: false,
                        extra_menu: false,
                        eco_menu: false,
                        emt_menu: false,
                      })
                    }
                    className={
                      this.state.Tab === 'master'
                        ? 'waves-effect active-menu'
                        : 'waves-effect'
                    }
                  >
                    <i className="mdi mdi-account-multiple"></i>{' '}
                    <span>
                      People
                      <span className="pull-right">
                        <i className="mdi mdi-chevron-right"></i>
                      </span>{' '}
                    </span>{' '}
                  </Link>
                  <ul
                    className="list-unstyled"
                    style={{ display: this.state.product ? 'block' : 'none' }}
                  >
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'Members' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'Members', '')}
                        to="/members"
                      >
                        Members
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'Teams' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'Teams', '')}
                        to="/teams"
                      >
                        Teams{' '}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'Title' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'Title', '')}
                        to="/titles"
                      >
                        Titles
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={
                    this.state.project
                      ? 'has_sub active-menu nav-active'
                      : 'has_sub'
                  }
                  id="a87ec3a0-83a8-4441-9813-e53faaaa951e"
                >
                  <Link
                    to="#"
                    onClick={() =>
                      this.setState({
                        project: !this.state.project,
                        dashboard_menu: false,
                        monitoring: false,
                        product: false,
                        form_menu: false,
                        chart_menu: false,
                        table_menu: false,
                        icon_menu: false,
                        map_menu: false,
                        auth_menu: false,
                        extra_menu: false,
                        eco_menu: false,
                        emt_menu: false,
                      })
                    }
                    className={
                      this.state.Tab === 'master'
                        ? 'waves-effect active-menu'
                        : 'waves-effect'
                    }
                  >
                    <i className="fa fa-briefcase"></i>{' '}
                    <span>
                      Projects
                      <span className="pull-right">
                        <i className="mdi mdi-chevron-right"></i>
                      </span>{' '}
                    </span>{' '}
                  </Link>
                  <ul
                    className="list-unstyled"
                    style={{ display: this.state.project ? 'block' : 'none' }}
                  >
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'project' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'project', '')}
                        to="/projects"
                      >
                        Projects
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'Task' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'Task', '')}
                        to="/tasks"
                      >
                        Tasks
                      </Link>
                    </li>
                    {/* <li><Link className={this.state.SubTab === 'contracts' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'contracts','')}  to="/contracts">Contracts</Link></li> */}
                    {/* <li><Link className={this.state.SubTab === 'Completed Auction' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'Completed Auction','')}  to="/product-AuctionCompleted">Completed Auction</Link></li> */}
                  </ul>
                </li>

                <li
                  className={
                    this.state.timeOff
                      ? 'has_sub active-menu nav-active'
                      : 'has_sub'
                  }
                  id="a87ec3a0-83a8-4441-9813-e53faaaa951e"
                >
                  <Link
                    to="#"
                    onClick={() =>
                      this.setState({
                        timeOff: !this.state.timeOff,
                        analyze: false,
                        monitoring: false,
                        ui_menu: false,
                        project: false,
                        product: false,
                        table_menu: false,
                        icon_menu: false,
                        map_menu: false,
                        auth_menu: false,
                        extra_menu: false,
                        eco_menu: false,
                        emt_menu: false,
                      })
                    }
                    className={
                      this.state.Tab === 'master'
                        ? 'waves-effect active-menu'
                        : 'waves-effect'
                    }
                  >
                    <i className="fa fa-calendar-minus-o"></i>{' '}
                    <span>
                      Time Off
                      <span className="pull-right">
                        <i className="mdi mdi-chevron-right"></i>
                      </span>{' '}
                    </span>{' '}
                  </Link>
                  <ul
                    className="list-unstyled"
                    style={{ display: this.state.timeOff ? 'block' : 'none' }}
                  >
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'holiday' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'holiday', '')}
                        to="/holidays"
                      >
                        Holidays
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'leavePolicy'
                            ? 'active-menu'
                            : ''
                        }
                        onClick={this.setActiveTab.bind(
                          this,
                          'leavePolicy',
                          ''
                        )}
                        to="/leave-policy"
                      >
                        Leave Policy
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'leave' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'leave', '')}
                        to="/leave"
                      >
                        Leave{' '}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'balance' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'balance', '')}
                        to="/leave-balance"
                      >
                        Leave Balance
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="menu-title">DOWNLOADS</li>

                <li>
                  <a
                    href={getSoftwareAppLinks().windowsEXEs}
                    download
                    className="menu-link"
                  >
                    <i className="mdi mdi-windows"></i> Windows EXE
                  </a>
                </li>

                <li>
                  <a
                    href="/assets/help-docs/WebtrackerWindowshelp.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="menu-link"
                  >
                    <i className="mdi mdi-help-circle-outline"></i> Windows Help
                  </a>
                </li>

                {/* <li>
                  <a
                    href={getSoftwareAppLinks().macDMGs}
                    download
                    className="menu-link"
                  >
                    <i className="mdi mdi-apple"></i> MAC DMG
                  </a>
                </li> */}

                <li>
                  <a
                    href="/assets/help-docs/WebtrackerMachelp.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="menu-link"
                  >
                    <i className="mdi mdi-help-circle-outline"></i> MAC Help
                  </a>
                </li>

                <li className="menu-title">CONTACT US</li>

                <li>
                  <Link
                    className={
                      this.state.SubTab === 'support' ? 'active-menu' : ''
                    }
                    onClick={this.setActiveTab.bind(
                      this,
                      'index',
                      'support',
                      ''
                    )}
                    to="/support"
                  >
                    <i className="mdi mdi-message-outline"></i> Support
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      this.state.SubTab === 'chat' ? 'active-menu' : ''
                    }
                    onClick={this.setActiveTab.bind(this, 'index', 'chat', '')}
                    to="/chats"
                  >
                    <i className="mdi mdi-message-outline"></i> Chats
                  </Link>
                </li>

                {/* <li  className={this.state.ui_menu ? 'has_sub active-menu nav-active' : 'has_sub'}>
                            <Link to="#"  onClick={()=> this.setState({ ui_menu: !this.state.ui_menu, email_menu : false, dashboard_menu: false,form_menu: false,chart_menu: false,table_menu: false,icon_menu: false,map_menu: false,auth_menu: false,extra_menu: false,eco_menu: false,emt_menu: false }) }  className={this.state.Tab === 'ui' ? 'waves-effect active-menu':'waves-effect'}><i className="mdi mdi-buffer"></i> <span> User Interface <span className="pull-right"><i className="mdi mdi-chevron-right"></i></span> </span> </Link>
                            <ul className="list-unstyled" style={{display: this.state.ui_menu ? 'block' : 'none' }}>
                                <li><Link className={this.state.SubTab === 'buttons' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','buttons','')} to="buttons">Buttons</Link></li>
                                <li><Link className={this.state.SubTab === 'colors' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','colors','')} to="colors">Colors</Link></li>
                                <li><Link className={this.state.SubTab === 'cards' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','cards','')} to="cards">Cards</Link></li>
                                <li><Link className={this.state.SubTab === 'tabs_accordions' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','tabs_accordions','')} to="tabs_accordions">Tabs &amp; Accordions</Link></li>
                                <li><Link className={this.state.SubTab === 'modals' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','modals','')} to="modals">Modals</Link></li>
                                <li><Link className={this.state.SubTab === 'images' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','images','')} to="images">Images</Link></li>
                                <li><Link className={this.state.SubTab === 'alerts' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','alerts','')} to="alerts">Alerts</Link></li>
                                <li><Link className={this.state.SubTab === 'progressbars' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','progressbars','')} to="progressbars">Progress Bars</Link></li>
                                <li><Link className={this.state.SubTab === 'dropdowns' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','dropdowns','')} to="dropdowns">Dropdowns</Link></li>
                                <li><Link className={this.state.SubTab === 'lightbox' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','lightbox','')} to="lightbox">Lightbox</Link></li>
                                <li><Link className={this.state.SubTab === 'navs' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','navs','')} to="navs">Navs</Link></li>
                                <li><Link className={this.state.SubTab === 'pagination' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','pagination','')} to="pagination">Pagination</Link></li>
                                <li><Link className={this.state.SubTab === 'popover_tooltips' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','popover_tooltips','')} to="popover_tooltips">Popover & Tooltips</Link></li>
                                <li><Link className={this.state.SubTab === 'badge' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','badge','')} to="badge">Badge</Link></li>
                                <li><Link className={this.state.SubTab === 'carousel' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','carousel','')} to="carousel">Carousel</Link></li>
                                <li><Link className={this.state.SubTab === 'video' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','video','')} to="video">Video</Link></li>
                                <li><Link className={this.state.SubTab === 'typography' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','typography','')} to="typography">Typography</Link></li>
                                <li><Link className={this.state.SubTab === 'sweet_alert' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','sweet_alert','')} to="sweet_alert">Sweet-Alert</Link></li>
                                <li><Link className={this.state.SubTab === 'grid' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','grid','')} to="grid">Grid</Link></li>
                                <li><Link className={this.state.SubTab === 'animation' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','animation','')} to="animation">Animation</Link></li>
                                <li><Link className={this.state.SubTab === 'highlight' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','highlight','')} to="highlight">Highlight</Link></li>
                                <li><Link className={this.state.SubTab === 'rating' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','rating','')} to="rating">Rating</Link></li>
                                <li><Link className={this.state.SubTab === 'nestable' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','nestable','')} to="nestable">Nestable</Link></li>
                                <li><Link className={this.state.SubTab === 'alertify' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','alertify','')} to="alertify">Alertify</Link></li>
                                <li><Link className={this.state.SubTab === 'rangeslider' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','rangeslider','')} to="rangeslider">Range Slider</Link></li>
                                <li><Link className={this.state.SubTab === 'sessiontimeout' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'ui','sessiontimeout','')} to="sessiontimeout">Session Timeout</Link></li>
                            </ul>
                           

                        </li> */}

                {/* <li  className={this.state.form_menu ? 'has_sub active-menu nav-active' : 'has_sub'}>
                            <Link to="#"  onClick={()=> this.setState({ form_menu: !this.state.form_menu, dashboard_menu : false, email_menu : false, ui_menu: false,chart_menu: false,table_menu: false,icon_menu: false,map_menu: false,auth_menu: false,extra_menu: false,eco_menu: false,emt_menu: false }) }  className={this.state.Tab === 'form' ? 'waves-effect active':'waves-effect'}><i className="mdi mdi-clipboard-outline"></i><span> Forms <span className="badge badge-pill badge-success pull-right">9</span> </span></Link>
                            <ul className="list-unstyled"  style={{display: this.state.form_menu ? 'block' : 'none' }}>
                                <li><Link className={this.state.SubTab === 'form_elements' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'form','form_elements','')} to="form_elements">Form Elements</Link></li>
                                <li><Link className={this.state.SubTab === 'form_validation' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'form','form_validation','')} to="form_validation">Form Validation</Link></li>
                                <li><Link className={this.state.SubTab === 'form_advanced' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'form','form_advanced','')} to="form_advanced">Form Advanced</Link></li>
                                <li><Link className={this.state.SubTab === 'form_wizard' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'form','form_wizard','')} to="form_wizard">Form Wizard</Link></li>
                                <li><Link className={this.state.SubTab === 'form_editors' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'form','form_editors','')} to="form_editors">Form Editors</Link></li>
                                <li><Link className={this.state.SubTab === 'form_uploads' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'form','form_uploads','')} to="form_uploads">Form File Upload</Link></li>
                                <li><Link className={this.state.SubTab === 'form_mask' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'form','form_mask','')} to="form_mask">Form Mask</Link></li>
                                <li><Link className={this.state.SubTab === 'form_summernote' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'form','form_summernote','')} to="form_summernote">Summernote</Link></li>
                                <li><Link className={this.state.SubTab === 'form_xeditable' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'form','form_xeditable','')} to="form_xeditable">Form Xeditable</Link></li>
                            </ul>
                        </li> */}

                {/* <li  className={this.state.chart_menu ? 'has_sub active-menu nav-active' : 'has_sub'}>
                            <Link to="#" onClick={()=> this.setState({ chart_menu: !this.state.chart_menu,dashboard_menu : false, email_menu : false, ui_menu: false,form_menu: false,table_menu: false,icon_menu: false,map_menu: false,auth_menu: false,extra_menu: false,eco_menu: false,emt_menu: false }) }  className={this.state.Tab === 'chart' ? 'waves-effect active':'waves-effect'}><i className="mdi mdi-chart-line"></i><span> Charts <span className="pull-right"><i className="mdi mdi-chevron-right"></i></span> </span></Link>
                            <ul className="list-unstyled" style={{display: this.state.chart_menu ? 'block' : 'none' }}>
                                <li><Link className={this.state.SubTab === 'charts_easy' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'chart','charts_easy','')} to="charts_easy">Easy Chart</Link></li>
                                <li><Link className={this.state.SubTab === 'chartjs' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'chart','chartjs','')} to="chartjs">ChartJs Chart</Link></li>
                                <li><Link className={this.state.SubTab === 'apexchart' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'chart','apexchart','')} to="apexchart">Apex Chart</Link></li>
                                <li><Link className={this.state.SubTab === 'sparkline' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'chart','sparkline','')} to="sparkline">SparkLine Chart</Link></li>
                            </ul>
                        </li> */}

                {/* <li className={this.state.table_menu ? 'has_sub active-menu nav-active' : 'has_sub'}>
                            <Link to="#" onClick={()=> this.setState({ table_menu: !this.state.table_menu,dashboard_menu : false, email_menu : false, ui_menu: false,form_menu: false,chart_menu: false,icon_menu: false,map_menu: false,auth_menu: false,extra_menu: false,eco_menu: false,emt_menu: false }) }  className={this.state.Tab === 'table' ? 'waves-effect active-menu':'waves-effect'}><i className="mdi mdi-format-list-bulleted-type"></i><span> Tables <span className="pull-right"><i className="mdi mdi-chevron-right"></i></span> </span></Link>
                            <ul className="list-unstyled" style={{display: this.state.table_menu ? 'block' : 'none' }}>
                                <li><Link className={this.state.SubTab === 'tables_basic' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'table','tables_basic','')} to="tables_basic">Basic Tables</Link></li>
                                <li><Link className={this.state.SubTab === 'tables_datatable' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'table','tables_datatable','')} to="tables_datatable">Data Table</Link></li>
                                <li><Link className={this.state.SubTab === 'tables_responsive' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'table','tables_responsive','')} to="tables_responsive">Responsive Table</Link></li>
                                <li><Link className={this.state.SubTab === 'tables_editable' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'table','tables_editable','')} to="tables_editable">Editable Table</Link></li>
                            </ul>
                        </li> */}

                {/* <li className={this.state.icon_menu ? 'has_sub active-menu nav-active' : 'has_sub'}>
                            <Link to="#" onClick={()=> this.setState({ icon_menu: !this.state.icon_menu,dashboard_menu : false, email_menu : false, ui_menu: false,form_menu: false,chart_menu: false,table_menu: false,map_menu: false,auth_menu: false,extra_menu: false,eco_menu: false,emt_menu: false}) }  className={this.state.Tab === 'icon' ? 'waves-effect active-menu':'waves-effect'}><i className="mdi mdi-album"></i> <span> Icons  <span className="pull-right"><i className="mdi mdi-chevron-right"></i></span></span> </Link>
                            <ul className="list-unstyled" style={{display: this.state.icon_menu ? 'block' : 'none' }}>
                                <li><Link  className={this.state.SubTab === 'icons_material' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'icon','icons_material','')} to="icons_material">Material Design</Link></li>
                                <li><Link  className={this.state.SubTab === 'icons_ion' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'icon','icons_ion','')} to="icons_ion">Ion Icons</Link></li>
                                <li><Link  className={this.state.SubTab === 'icons_fontawesome' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'icon','icons_fontawesome','')} to="icons_fontawesome">Font Awesome</Link></li>
                                <li><Link  className={this.state.SubTab === 'icons_themify' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'icon','icons_themify','')} to="icons_themify">Themify Icons</Link></li>
                                <li><Link  className={this.state.SubTab === 'icons_dripicons' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'icon','icons_dripicons','')} to="icons_dripicons">Dripicons</Link></li>
                                <li><Link  className={this.state.SubTab === 'icons_typicons' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'icon','icons_typicons','')} to="icons_typicons">Typicons I_ons</Link></li>
                                <li><Link  className={this.state.SubTab === 'icons_weather' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'icon','icons_weather','')} to="icons_weather">Weather Icons</Link></li>
                                <li><Link  className={this.state.SubTab === 'icons_mobirise' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'icon','icons_mobirise','')} to="icons_mobirise">Mobirise Icons</Link></li>
                            </ul>
                        </li> */}

                {/* <li className="menu-title">Extras</li>

                        <li className={this.state.auth_menu ? 'has_sub active-menu nav-active' : 'has_sub'}>
                            <Link to="#" onClick={()=> this.setState({ auth_menu: !this.state.auth_menu,dashboard_menu : false, email_menu : false, ui_menu: false,form_menu: false,chart_menu: false,table_menu: false,icon_menu: false,map_menu: false,extra_menu: false,eco_menu: false,emt_menu: false }) } className="waves-effect"><i className="mdi mdi-account-location"></i><span> Authentication <span className="pull-right"><i className="mdi mdi-chevron-right"></i></span> </span></Link>
                            <ul className="list-unstyled"  style={{display: this.state.auth_menu ? 'block' : 'none' }}>
                                <li><Link to="pages_login">Login</Link></li>
                                <li><Link to="pages_register">Register</Link></li>
                                <li><Link to="pages_recoverpw">Recover Password</Link></li>
                                <li><Link to="pages_lock_screen">Lock Screen</Link></li>
                                <li><Link to="pages_login_2">Login 2</Link></li>
                                <li><Link to="pages_register_2">Register 2</Link></li>
                                <li><Link to="pages_recoverpw_2">Recover Password 2</Link></li>
                                <li><Link to="pages_lock_screen_2">Lock Screen 2</Link></li>
                            </ul>
                        </li>

                        <li className={this.state.extra_menu ? 'has_sub active-menu nav-active' : 'has_sub'}>
                            <Link to="#" onClick={()=> this.setState({ extra_menu: !this.state.extra_menu,dashboard_menu : false, email_menu : false, ui_menu: false,form_menu: false,chart_menu: false,table_menu: false,icon_menu: false,map_menu: false,auth_menu: false,eco_menu: false,emt_menu: false }) }  className={this.state.Tab === 'extra' ? 'waves-effect active-menu':'waves-effect'}><i className="mdi mdi-google-pages"></i><span> Extra Pages <span className="pull-right"><i className="mdi mdi-chevron-right"></i></span> </span></Link>
                            <ul className="list-unstyled"  style={{display: this.state.extra_menu ? 'block' : 'none' }}>
                                <li><Link className={this.state.SubTab === 'pages_timeline' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'extra','pages_timeline','')}  to="pages_timeline">Timeline</Link></li>
                                <li><Link className={this.state.SubTab === 'pages_invoice' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'extra','pages_invoice','')}  to="pages_invoice">Invoice</Link></li>
                                <li><Link className={this.state.SubTab === 'pages_directory' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'extra','pages_directory','')}  to="pages_directory">Directory</Link></li>
                                <li><Link className={this.state.SubTab === 'pages_blank' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'extra','pages_blank','')}  to="pages_blank">Blank Page</Link></li>
                                <li><Link className={this.state.SubTab === 'pages_400' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'extra','pages_400','')}  to="pages_400">Error 404</Link></li>
                                <li><Link className={this.state.SubTab === 'pages_500' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'extra','pages_500','')}  to="pages_500">Error 500</Link></li>
                                <li><Link className={this.state.SubTab === 'pages_pricing' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'extra','pages_pricing','')}  to="pages_pricing">Pricing</Link></li>
                                <li><Link className={this.state.SubTab === 'pages_gallery' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'extra','pages_gallery','')}  to="pages_gallery">Gallery</Link></li>
                                <li><Link className={this.state.SubTab === 'pages_maintenance' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'extra','pages_maintenance','')}  to="pages_maintenance">Maintenance</Link></li>
                                <li><Link className={this.state.SubTab === 'pages_coming_soon' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'extra','pages_coming_soon','')}  to="pages_coming_soon">Coming Soon</Link></li>
                            </ul>
                        </li>

                        <li className={this.state.eco_menu ? 'has_sub active-menu nav-active' : 'has_sub'}>
                            <Link to="#" onClick={()=> this.setState({ eco_menu: !this.state.eco_menu,dashboard_menu : false, email_menu : false, ui_menu: false,form_menu: false,chart_menu: false,table_menu: false,icon_menu: false,map_menu: false,auth_menu: false,extra_menu: false,emt_menu: false }) }   className={this.state.Tab === 'eco' ? 'waves-effect active-menu':'waves-effect'}><i className="mdi mdi-cart-outline"></i><span> Ecommerce <span className="pull-right"><i className="mdi mdi-chevron-right"></i></span> </span></Link>
                            <ul className="list-unstyled" style={{display: this.state.eco_menu ? 'block' : 'none' }}>
                                <li><Link className={this.state.SubTab === 'ecommerce_product_list' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'eco','ecommerce_product_list','')}  to="ecommerce_product_list">Product List</Link></li>
                                <li><Link className={this.state.SubTab === 'ecommerce_product_grid' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'eco','ecommerce_product_grid','')}  to="ecommerce_product_grid">Product Grid</Link></li>
                                <li><Link className={this.state.SubTab === 'ecommerce_order_history' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'eco','ecommerce_order_history','')}  to="ecommerce_order_history">Order History</Link></li>
                                <li><Link className={this.state.SubTab === 'ecommerce_customers' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'eco','ecommerce_customers','')}  to="ecommerce_customers">Customers</Link></li>
                                <li><Link className={this.state.SubTab === 'ecommerce_product_edit' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'eco','ecommerce_product_edit','')}  to="ecommerce_product_edit">Product Edit</Link></li>
                            </ul>
                        </li>

                        <li>
                            <a href="/" className="waves-effect" target="_blank"><i className="mdi mdi-airplane"></i><span> Front End </span></a>
                        </li>

                        <li className={this.state.emt_menu ? 'has_sub active-menu nav-active' : 'has_sub'}>
                            <Link to="#" onClick={()=> this.setState({ emt_menu: !this.state.emt_menu,dashboard_menu : false, email_menu : false, ui_menu: false,form_menu: false,chart_menu: false,table_menu: false,icon_menu: false,map_menu: false,auth_menu: false,extra_menu: false,eco_menu: false }) }  className={this.state.Tab === 'emt' ? 'waves-effect active-menu':'waves-effect'}><i className="mdi mdi-flask-outline"></i><span> Email Templates <span className="pull-right"><i className="mdi mdi-chevron-right"></i></span> </span></Link>
                            <ul className="list-unstyled"  style={{display: this.state.emt_menu ? 'block' : 'none' }}>
                                <li><Link  className={this.state.SubTab === 'email_templates_basic' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'emt','email_templates_basic','')} to="email_templates_basic">Basic Action Email</Link></li>
                                <li><Link  className={this.state.SubTab === 'email_templates_alert' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'emt','email_templates_alert','')} to="email_templates_alert">Alert Email</Link></li>
                                <li><Link  className={this.state.SubTab === 'email_templates_billing' ? 'active-menu':''} onClick={this.setActiveTab.bind(this, 'emt','email_templates_billing','')} to="email_templates_billing">Billing Email</Link></li>
                            </ul>
                        </li> */}

                {/* <li className="menu-title">Help & Support</li>

                        <li>
                            <Link to="pages_faq" className={this.state.Tab === 'faq' ? 'waves-effect active-menu':'waves-effect'} onClick={this.setActiveTab.bind(this, 'faq','','')}><i className="mdi mdi-help-circle"></i><span> FAQ </span></Link>
                        </li>

                        <li>
                            <Link to="pages_contact" className={this.state.Tab === 'contact' ? 'waves-effect active-menu':'waves-effect'} onClick={this.setActiveTab.bind(this, 'contact','','')}><i className="mdi mdi-headset"></i><span> Contact <span className="badge badge-pill badge-warning pull-right">3</span> </span></Link>
                        </li>

                        <li>
                            <Link to="#" className="waves-effect"><i className="mdi mdi-file-document-box"></i><span> Documentation </span></Link>
                        </li> 
                        */}
              </ul>
            </div>

            <div className="clearfix"></div>
          </PerfectScrollbar>
        </div>
      </div>
    );
  }
}

sidebar.propsTypes = {
  // getRole: PropTypes.func.isRequired
};
var mapStateToProps = (state) => ({
  Webtracker: state.Webtracker,
});

export default withRouter(connect(mapStateToProps, {})(sidebar));
